import moment from 'moment-timezone';
import { CREATORS_PAGE_COUNT, RECORDINGS_PAGE_COUNT } from '../../Utils/Constants';
export const GET_ADMIN_RECORDINGS_REQUEST = 'GET_ADMIN_RECORDINGS_REQUEST';
export const GET_ADMIN_RECORDINGS_FAILURE = 'GET_ADMIN_RECORDINGS_FAILURE';
export const GET_ADMIN_RECORDINGS_SUCCESS = 'GET_ADMIN_RECORDINGS_SUCCESS';
export const TOGGLE_ADMIN_RECORDING = 'TOGGLE_ADMIN_RECORDING';
export const TOGGLE_ALL_ADMIN_RECORDINGS = 'TOGGLE_ALL_ADMIN_RECORDINGS';
export const ADMIN_RECORDINGS_POST_UNIQUE_TABLE_ID = 'ADMIN_RECORDINGS_POST_UNIQUE_TABLE_ID';
export const GET_RECORDING_CREATORS_REQUEST = 'GET_RECORDING_CREATORS_REQUEST';
export const GET_RECORDING_CREATORS_SUCCESS = 'GET_RECORDING_CREATORS_SUCCESS';
export const GET_RECORDING_CREATORS_FAILURE = 'GET_RECORDING_CREATORS_FAILURE';
export const RESET_RECORDING_CREATORS_REQUEST = 'RESET_RECORDING_CREATORS_REQUEST';

export function getAdminRecordings(
  accountKey,
  fromTime = moment()
    .subtract(6, 'month')
    .toISOString(),
  toTime = moment().toISOString(),
  creators = [],
  filter = '',
  page = 0,
  limit = RECORDINGS_PAGE_COUNT,
  loadPage = true
) {
  return {
    type: GET_ADMIN_RECORDINGS_REQUEST,
    payload: { accountKey, fromTime, toTime, creators, filter, page, limit, loadPage }
  };
}

export function toggleAdminRecording(recordingKey, isSelected, uniqueTableId) {
  return {
    type: TOGGLE_ADMIN_RECORDING,
    payload: { recordingKey, isSelected, uniqueTableId }
  };
}

export function toggleAllAdminRecordings(isSelected = true, uniqueTableId) {
  return {
    type: TOGGLE_ALL_ADMIN_RECORDINGS,
    payload: { isSelected, uniqueTableId }
  };
}

export function getRecordingCreators(
  accountKey,
  fromTime = moment()
    .subtract(6, 'month')
    .add(1, 'd')
    .startOf('day')
    .toISOString(),
  toTime = moment().toISOString(),
  page = 0,
  filter,
  limit = CREATORS_PAGE_COUNT,
  loadCreators = false
) {
  return {
    type: GET_RECORDING_CREATORS_REQUEST,
    payload: { accountKey, fromTime, toTime, page, filter, limit, loadCreators }
  };
}

export function resetRecordingCreators() {
  return {
    type: RESET_RECORDING_CREATORS_REQUEST
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/AdminRecordings/AdminRecordingsActions.js